export default "__VITE_ASSET__Bk$jiiut__"